import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Square } from "@phosphor-icons/react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Aug 2026, user's explicit ask: the SAP live/broken indicator that only
// existed on the BOM Explorer (home) page header should show on every
// page so a user always knows SAP's connection status, not just on one
// screen. Same endpoint/logic as BomExplorerPage's original indicator.
// Oct 13 2026, user's explicit ask ("eliminate this pill design...
// ERP-level professional"): rectangular "System Monitor" module (white
// chip, square LED, semantic text color) instead of a solid-color pill.
export const SapConnectionStatus = () => {
  const [connection, setConnection] = useState({ connected: null, message: "Checking connection..." });

  const checkConnection = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/bom/connection-status`);
      setConnection(data);
    } catch {
      setConnection({ connected: false, message: "Unable to reach backend" });
    }
  }, []);

  useEffect(() => {
    checkConnection();
    const interval = setInterval(checkConnection, 60000);
    return () => clearInterval(interval);
  }, [checkConnection]);

  const statusColor = connection.connected === null ? "#B45309" : connection.connected ? "#15803D" : "#B91C1C";

  return (
    <div
      className="flex items-center gap-1.5 px-2.5 py-1 rounded-[3px] border border-[#E2E8F0] bg-white shrink-0 text-[11px] font-bold tracking-wide shadow-sm"
      data-testid="connection-status-indicator"
      title={connection.message}
    >
      <Square size={8} weight="fill" style={{ color: statusColor }} className={connection.connected === null || connection.connected ? "animate-pulse" : ""} />
      <span className="font-sans whitespace-nowrap hidden md:inline uppercase" style={{ color: statusColor }}>
        {connection.connected === null
          ? "Checking SAP..."
          : connection.connected
          ? "SAP PRD"
          : "SAP Disconnected"}
      </span>
    </div>
  );
};
